import { Typography } from '@mui/material';
import { useSelector } from 'react-redux';

import type { State } from '../../types/states';
import { PdfPreviewEntry } from '../PropertyAdEditor/PdfPreviewEntry';
import { canUsePdfImport } from '../PropertyAdEditor/pdfImportAccess';
import { Dashboard } from './Dashboard';

export const PdfPreviewPage = () => {
  const user = useSelector(({ auth }: State) => auth.user);
  return (
    <Dashboard openLogIn>
      {canUsePdfImport(user) ? (
        <PdfPreviewEntry key={user?.id} />
      ) : (
        <Typography role='alert'>PDF import is unavailable for this account.</Typography>
      )}
    </Dashboard>
  );
};
